import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useRouter } from 'next/router';

import { useAppSelector } from 'store';

import { getUserProfileInfo } from '../queries';
import { profileConst } from '..';

export const useUserProfileInfo = () => {
  const { query } = useRouter();
  const userId = query?.id as string | undefined;
  const isAuthenticated = useAppSelector(({ authModal }) => authModal.isAuthenticated.status);

  const {
    data: userProfileInfo,
    error,
    ...args
  } = useQuery({
    queryKey: [profileConst.queryKeys.USER_PROFILE_INFO, userId || 'self'],
    queryFn: getUserProfileInfo(userId),
    enabled: isAuthenticated
  });

  return { userProfileInfo, error: error as AxiosError, ...args };
};
